
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import Const from '@/util/Const'

export default defineComponent({
  name: 'Footer',
  setup() {
    const { locale } = useI18n()
    const fluxCorporateWebsiteUrl = computed(() => {
      return Const.corporateUrl
    })
    const fluxTermsUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_TERMS_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_TERMS_PAGE_PATH}`
    })
    const fluxPrivacyPolicyUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH}`
    })
    const fluxContactUsUrl = computed(() => {
      const foreignUrl =
        locale.value === 'es'
          ? `${process.env.VUE_APP_FLUX_FOREIGN_SUPPORT_PAGE_BASE_URL}/es${process.env.VUE_APP_FLUX_FOREIGN_CONTACT_US_PAGE_PATH}`
          : process.env.VUE_APP_FLUX_FOREIGN_SUPPORT_PAGE_BASE_URL +
            process.env.VUE_APP_FLUX_FOREIGN_CONTACT_US_PAGE_PATH
      return locale.value === 'ja' ? process.env.VUE_APP_FLUX_CONTACT_US_PAGE_URL : foreignUrl
    })
    return {
      fluxCorporateWebsiteUrl,
      fluxTermsUrl,
      fluxPrivacyPolicyUrl,
      fluxContactUsUrl,
      ...useI18n(),
    }
  },
})
